module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r7r9n3n-594b54147334d27aed4e65a24e1f261d.svg";